export default "__VITE_ASSET__22ce10eb__"